import Duration from "../constants/Duration";

interface LoopStepBase {
  lastStep: boolean;

  metronome: true;
}

export interface LoopStepRest extends LoopStepBase {
  type: "rest";
}

export interface LoopStepPlay extends LoopStepBase {
  type: "degree";

  melody:
    | {
        degreesToPlay: number[];
        duration: Duration;
      }
    | undefined;

  chord:
    | {
        scaleDegree: number;
        duration: string;
      }
    | undefined;
}

export type LoopStep = LoopStepRest | LoopStepPlay;

export const loopInterval = Duration.quarterNote;

export function melodyDegreesToSteps(melodyDegrees: number[]): LoopStep[] {
  const steps: LoopStep[] = [];

  steps.push({
    type: "degree",
    lastStep: false,
    metronome: true,
    melody: undefined,
    chord: { duration: "4n", scaleDegree: 1 },
  });
  steps.push({ type: "rest", lastStep: false, metronome: true });

  melodyDegrees.forEach((degree) => {
    steps.push({
      type: "degree",
      metronome: true,
      melody: {
        degreesToPlay: [degree],
        duration: loopInterval,
      },
      chord: undefined,
      lastStep: false,
    });
  });

  steps.push({ type: "rest", lastStep: false, metronome: true });
  steps.push({ type: "rest", lastStep: true, metronome: true });

  return steps;
}
